export default function Lodingsubmit() {
  return (
    <div className="spinner-container-submit">
      <div className="spinner"></div>
    </div>
  );
}
